// Spot pages (template page.spot) and the spots map (template page.spots).
// Widget ids come from the kitegalicia.com / tmkites.com spot pages: Windguru spot ids,
// webcam pages and MeteoGalicia station codes. Tides: MeteoGalicia ports, baked into
// assets/tides.json by scripts/build_tides.py (their API has no CORS).
(function () {
  if (window.foilSpotsLoaded) return; // each Spots section includes this script; render once
  window.foilSpotsLoaded = true;
  var SPOTS = [
    { handle: 'o-vao', name: 'O Vao', area: 'Vigo', lat: 42.19865, lon: -8.79648, windguru: 1066, cams: [['Hispacams', 'https://www.hispacams.com/en/webcams/coruxo-playa-de-o-vao-toralla/']], station: 10125, tidePort: 3 },
    { handle: 'patos', name: 'Patos', area: 'Nigrán', lat: 42.15451, lon: -8.83454, windguru: 48742, station: 10125, tidePort: 3 },
    { handle: 'cesantes', name: 'Cesantes', area: 'Redondela', lat: 42.30764, lon: -8.62136, windguru: 48740, cams: [['TM Kites', 'https://www.tmkites.com/playas/cesantes/']], station: 10154, tidePort: 3 },
    { handle: 'lourido', name: 'Lourido', area: 'Poio', lat: 42.42119, lon: -8.68703, windguru: 501121, cams: [['camaramar', 'https://www.camaramar.com/webcam/galicia_pontevedra_lourido']], station: 10064, tidePort: 13 },
    { handle: 'a-lanzada', name: 'A Lanzada', area: 'O Grove', lat: 42.44735, lon: -8.88261, windguru: 48738, cams: [['camaramar (sur)', 'https://www.camaramar.com/webcam/galicia_pontevedra_lanzadasur'], ['camaramar (Noalla)', 'https://www.camaramar.com/webcam/galicia_pontevedra_lanzadanoalla']], station: 19069, tidePort: 4 },
    // kitegalicia uses station 10128, which MeteoGalicia no longer lists; A Lanzada (19069) is the nearest.
    { handle: 'a-mexilloeira', name: 'A Mexilloeira', area: 'O Grove', lat: 42.47539, lon: -8.91312, windguru: 501120, station: 19069, tidePort: 4 },
    { handle: 'o-bao', name: 'O Bao', area: 'A Illa de Arousa', lat: 42.54658, lon: -8.86209, windguru: 48737, station: 10085, tidePort: 4 },
    { handle: 'moledo', name: 'Moledo', area: 'Caminha (Portugal)', tz: 'Europe/Lisbon', lat: 41.84905, lon: -8.87374, windguru: 48935, cams: [['Surftotal Moledo', 'https://surftotal.com/camaras-report/minho/moledo'], ['Surftotal Viana do Castelo', 'https://surftotal.com/camaras-report/minho/viana-do-castelo-hd']], station: 10091, tidePort: 10 }
  ];
  // Secret spots arrive only for VIP visitors, as JSON rendered by Liquid (snippets/secret-spots-data.liquid).
  var vipData = document.querySelector('script[data-vip-spots]');
  if (vipData) SPOTS.unshift.apply(SPOTS, JSON.parse(vipData.textContent).map(function (s) { s.secret = true; return s; }));
  var PORTS = { 3: 'Vigo', 4: 'Vilagarcía', 10: 'A Guarda', 13: 'Pontevedra', 15: 'Marín' };
  var TZ = 'Europe/Madrid';

  function pageUrl(spot) { return '/pages/' + spot.handle; }
  function time(d) { return isNaN(d) ? '–' : d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: TZ }); }

  function block(root, title, html) {
    var el = document.createElement('div');
    el.className = 'spot-block';
    el.innerHTML = '<h2 class="h3">' + title + '</h2>' + (html || '');
    root.appendChild(el);
    return el;
  }

  function iframe(src, title, cls) {
    return '<div class="' + (cls || 'spot-frame') + '"><iframe src="' + src + '" title="' + title +
      '" loading="lazy" allowfullscreen allow="autoplay; fullscreen" referrerpolicy="no-referrer-when-downgrade"></iframe></div>';
  }

  // From an hour before today's sunrise to an hour after sunset, rounded to the nearest hour in the spot's local
  // time, which is what Windguru shows (Portugal is an hour behind). Each day of the widget then shows only these
  // hours, both included. All day if SunCalc didn't load.
  function daylight(spot) {
    if (!window.SunCalc) return [0, 24];
    var sun = SunCalc.getTimes(new Date(), spot.lat, spot.lon);
    var hour = function (d) {
      var hm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: spot.tz || TZ }).split(':');
      return Math.round(+hm[0] + hm[1] / 60);
    };
    var from = hour(sun.sunrise), to = hour(sun.sunset);
    return isNaN(from) || isNaN(to) ? [0, 24] : [Math.max(0, from - 1), Math.min(24, to + 1)];
  }

  // Windguru's AROME-FR 1.3 km (m=52), about 2 days ahead, unless a spot sets windguruModel (3 = GFS 13 km). Its
  // widgets show AROME (a PRO model) only for official Windguru spots, not ones users added, and at most 20
  // different forecasts (spot × model) per domain.
  function windguru(el, spot, hours, params) {
    var model = spot.windguruModel || 52;
    var uid = 'wg_fwdg_' + spot.windguru + '_' + model + '_' + Date.now();
    var day = daylight(spot);
    var anchor = document.createElement('div');
    anchor.id = uid; // the Windguru loader inserts its iframe right after this element
    el.appendChild(anchor);
    var s = document.createElement('script');
    s.src = 'https://www.windguru.cz/js/widget.php?' + ['s=' + spot.windguru, 'm=' + model, 'uid=' + uid, 'wj=knots', 'tj=c', 'waj=m',
      'tij=cm', 'odh=' + day[0], 'doh=' + day[1], 'fhours=' + (hours || 240), 'hrsm=2', 'vt=forecasts', 'lng=es', 'idbs=1',
      'p=' + (params || 'WINDSPD,GUST,MWINDSPD,SMER,TMPE,FLHGT,CDC,APCP1s')].join('&');
    el.appendChild(s);
  }

  // Our own forecast (the weather API's /forecast): one column per hour from an hour before sunrise to an hour
  // after sunset, days side by side, wind and gust coloured by strength, direction arrows, and under them what the
  // station measured in the hours already past. maxDays limits the days; wrf = MeteoGalicia's WRF 1 km instead of
  // our usual models (no gusts); nothing shows if the API fails.
  var WRF = 'meteogalicia_wrf_1km';
  function forecast(el, spot, maxDays, wrf) {
    var box = el.appendChild(document.createElement('div')); // keeps the widgets in call order
    fetch('/apps/foil/spots/' + spot.handle + '/forecast' + (wrf ? '?model=' + WRF : '')).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (fc) {
      var days = fc.days.slice(0, maxDays || 7);
      if (!days.length) return;
      var hours = [].concat.apply([], days.map(function (d) {
        return d.hours.map(function (h, i) { h.first = i === 0; return h; });
      }));
      var now = Date.now(), current = -1;
      hours.forEach(function (h, i) { if (new Date(h.at) <= now && now - new Date(h.at) < 3600000) current = i; });
      var cls = function (h, i) { // a line before each day, the current hour highlighted
        var c = ((h.first ? 'fc__first ' : '') + (i === current ? 'fc__now' : '')).trim();
        return c ? ' class="' + c + '"' : '';
      };
      var td = function (h, i, html, style) { return '<td' + cls(h, i) + (style ? ' style="' + style + '"' : '') + '>' + html + '</td>'; };
      var kn = function (pick) {
        return hours.map(function (h, i) { var v = pick(h); return v == null ? td(h, i, '') : td(h, i, Math.round(v), 'background:' + knotsColor(v)); }).join('');
      };
      var arrows = function (pick) {
        return hours.map(function (h, i) {
          var d = pick(h);
          return td(h, i, d == null ? '' : '<span class="fc__arrow" style="transform:rotate(' + d + 'deg)" title="' +
            DIRS[Math.round(d / 45) % 8] + ' ' + d + '°">↓</span>');
        }).join('');
      };
      var row = function (label, cells, cls) { return '<tr' + (cls ? ' class="' + cls + '"' : '') + '><th scope="row">' + label + '</th>' + cells + '</tr>'; };
      var reading = function (key) { return function (h) { return h.reading && h.reading[key]; }; };
      var readings = hours.some(function (h) { return h.reading; });
      var gusts = hours.some(function (h) { return h.gust_kn != null; });
      var hd = hours.some(function (h) { return h.hd_kn != null; }); // AROME 1.3 km, to compare with the 2.5 km above
      box.insertAdjacentHTML('beforeend', '<p class="fc__title"><strong>' + (wrf ? 'MeteoGalicia WRF 1 km' : 'Previsión Foil Fanatics') +
        '</strong> (en pruebas)</p><div class="fc"><table class="fc__table">' +
        '<thead><tr><td></td>' + days.map(function (d) {
          var models = d.hours.map(function (h) { return MODELS[h.model] || h.model; }).filter(function (m, i, all) { return all.indexOf(m) === i; });
          return '<th scope="colgroup" colspan="' + d.hours.length + '" class="fc__first">' + dayLabel(d.date) + ' <small>' + models.join(', ') + '</small></th>';
        }).join('') + '</tr><tr><td></td>' + hours.map(function (h, i) {
          var hour = new Date(h.at).toLocaleTimeString('es-ES', { hour: '2-digit', hourCycle: 'h23', timeZone: TZ });
          return '<th scope="col"' + cls(h, i) + '>' + hour + '</th>';
        }).join('') + '</tr></thead><tbody>' +
        row('Viento (kn)', kn(function (h) { return h.wind_kn; })) +
        (gusts ? row('Racha (kn)', kn(function (h) { return h.gust_kn; })) : '') +
        row('Dirección', arrows(function (h) { return h.dir; })) +
        (hd ? row('AROME HD (kn)', kn(function (h) { return h.hd_kn; }), 'fc__alt') : '') +
        (readings ? row('Medido: viento', kn(reading('wind_kn')), 'fc__real') + row('Medido: racha', kn(reading('gust_kn'))) +
          row('Medido: dirección', arrows(reading('dir'))) : '') +
        '</tbody></table></div><p class="spot-source">' + (wrf ? 'Previsión: modelo WRF de MeteoGalicia a 1 km (MeteoSIX), una ' +
        'pasada al día, sin rachas. ' : 'Previsión: AROME (Météo-France) los 2 primeros días, luego ICON-EU y ECMWF; datos de ' +
        'Open-Meteo (CC BY 4.0). ' + (hd ? 'AROME HD: el mismo modelo a 1,3 km (arriba, 2,5 km); Open-Meteo lo publica unas dos ' +
        'veces al día, así que su pasada (' + new Date(fc.hd_run).toLocaleString('es-ES', { weekday: 'short', hour: '2-digit',
        minute: '2-digit', timeZone: TZ }) + ') suele ser más antigua. ' : '')) + 'Medido: estación de MeteoGalicia, media y racha máxima de cada hora.</p>');
      // Today has all 24 hours: start scrolled to the current one, with a few hours before it in view.
      var nowCell = box.querySelector('thead .fc__now');
      if (nowCell) box.querySelector('.fc').scrollLeft = Math.max(0, nowCell.offsetLeft - 4 * nowCell.offsetWidth - box.querySelector('tbody th').offsetWidth);
    }).catch(function () {});
  }

  function stationSrc(spot) {
    return 'https://servizos.meteogalicia.gal/widget/html/widget_estacions.html?codigo=' + spot.station + '&language=es&formato=normal' +
      '&temperatura=true&viento=true&choiva=false&sol=false&refacho=true&tempmin=false&tempmax=false&tendencia=true&fondo=F3F3F8';
  }

  // Live wind from our weather API (foilfanatics.com/apps/foil: a Shopify app proxy to api.foilfanatics.com).
  // The API serves secret spots only to customers tagged VIP. Falls back to the MeteoGalicia widget if it fails.
  var DIRS = ['N', 'NE', 'E', 'SE', 'S', 'SO', 'O', 'NO'];
  function knotsColor(kn) {
    return kn < 8 ? '#b9dcf0' : kn < 12 ? '#7ccf8a' : kn < 16 ? '#f1d54b' : kn < 20 ? '#f39c3d' : kn < 25 ? '#e2523f' : '#a64ac9';
  }

  function fetchNow(spot) {
    return fetch('/apps/foil/spots/' + spot.handle + '/now').then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (d) {
      if (!d.now) throw new Error('no readings');
      return d;
    });
  }

  // Mean of the last 2 hours' 10-minute readings, in knots; -1 when there are none.
  function meanWind(d) {
    var w = d.trend.map(function (t) { return t.wind_kn; }).filter(function (v) { return v != null; });
    return w.length ? w.reduce(function (a, b) { return a + b; }, 0) / w.length : -1;
  }

  // request: a fetchNow(spot) the caller already started (Vista Rápida sorts on the results first).
  function liveWind(el, spot, request) {
    function fallback() { el.insertAdjacentHTML('beforeend', iframe(stationSrc(spot), 'Estación MeteoGalicia', 'spot-frame spot-frame--station')); }
    (request || fetchNow(spot)).then(function (d) {
      var n = d.now, kn = function (v) { return v == null ? '–' : Math.round(v); };
      var mins = Math.round((Date.now() - new Date(n.at)) / 60000);
      var max = Math.max.apply(null, d.trend.map(function (t) { return t.gust_kn || t.wind_kn || 0; }).concat(10));
      // One slot per 10 minutes back from the latest reading, so a missing reading shows as an empty slot.
      var byTime = {}, slots = [];
      d.trend.forEach(function (t) { byTime[t.at] = t; });
      for (var i = 12; i >= 0; i--) slots.push(new Date(new Date(n.at) - i * 600000));
      var bars = slots.map(function (at) {
        var t = byTime[at.toISOString().replace('.000Z', 'Z')];
        if (!t) return '<span title="' + time(at) + ': sin lectura"></span>';
        return '<span title="' + time(at) + ': ' + kn(t.wind_kn) + ' kn, racha ' + kn(t.gust_kn) + ' kn">' +
          '<b style="height:' + 100 * t.wind_kn / max + '%;background:' + knotsColor(t.wind_kn) + '"></b>' +
          (t.gust_kn == null ? '' : '<i style="bottom:' + 100 * t.gust_kn / max + '%"></i>') + '</span>';
      }).join('');
      var times = slots.map(function (at) { return '<span>' + (at.getUTCMinutes() % 30 ? '' : time(at)) + '</span>'; }).join('');
      var dir = n.dir == null ? '–' : '<span class="live-wind__arrow" aria-hidden="true" style="transform:rotate(' + n.dir + 'deg)">↓</span> ' +
        DIRS[Math.round(n.dir / 45) % 8] + ' ' + Math.round(n.dir) + '°';
      el.insertAdjacentHTML('beforeend', '<div class="live-wind">' +
        '<div class="live-wind__now">' +
        '<div><span class="live-wind__value" style="border-color:' + knotsColor(n.wind_kn) + '">' + kn(n.wind_kn) + '</span> kn<small>Viento medio</small></div>' +
        '<div><span class="live-wind__value" style="border-color:' + knotsColor(n.gust_kn) + '">' + kn(n.gust_kn) + '</span> kn<small>Racha</small></div>' +
        '<div><span class="live-wind__dir">' + dir + '</span><small>Dirección</small></div></div>' +
        (mins > 30 ? '<p><strong>La estación no envía datos desde hace ' + mins + ' min.</strong></p>' : '') +
        '<div class="live-wind__trend" role="img" aria-label="Viento de las últimas 2 horas">' + bars + '</div>' +
        '<div class="live-wind__times" aria-hidden="true">' + times + '</div>' +
        '<p class="spot-source">Lectura de las ' + time(new Date(n.at)) + ' (hace ' + mins + ' min)' + (n.temp == null ? '' : ' · ' + Math.round(n.temp) + ' °C') +
        '. Últimas 2 horas, una barra cada 10 min: barra = viento medio, raya = racha. Datos: estación MeteoGalicia.</p></div>');
    }).catch(fallback);
  }

  function dayLabel(d) { return new Date(d + 'T12:00:00').toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }); }

  // One day's tide curve as SVG: cosine interpolation between high and low tides (the usual approximation between
  // extremes), using the neighbouring days' extremes so the curve reaches both midnights. Times are local wall-clock.
  function tideChart(port, days, i, now) {
    var ext = [];
    [-1, 0, 1].forEach(function (k) {
      (port[days[i + k]] || []).forEach(function (t) {
        var hm = t[0].split(':');
        ext.push({ m: k * 1440 + hm[0] * 60 + +hm[1], h: t[1], high: t[2], time: t[0] });
      });
    });
    if (ext.length < 2) return '';
    var W = 420, H = 150, top = 22, bottom = 118, max = 0;
    days.forEach(function (d) { port[d].forEach(function (t) { max = Math.max(max, t[1]); }); });
    var x = function (m) { return (m / 1440 * W).toFixed(1); };
    var y = function (h) { return (bottom - h / max * (bottom - top)).toFixed(1); };
    var pts = [];
    for (var m = 0; m <= 1440; m += 10) {
      var j = 0;
      while (j < ext.length - 2 && ext[j + 1].m < m) j++;
      var a = ext[j], b = ext[j + 1], f = Math.min(1, Math.max(0, (m - a.m) / (b.m - a.m)));
      pts.push(x(m) + ',' + y(a.h + (b.h - a.h) * (1 - Math.cos(Math.PI * f)) / 2));
    }
    var today = ext.filter(function (e) { return e.m >= 0 && e.m < 1440; });
    var marks = today.map(function (e) {
      var cx = Math.min(W - 18, Math.max(18, x(e.m)));
      return '<circle cx="' + x(e.m) + '" cy="' + y(e.h) + '" r="3.5"/>' +
        '<text x="' + cx + '" y="' + (e.high ? y(e.h) - 8 : +y(e.h) + 16) + '">' + e.h.toFixed(1) + ' m</text>' +
        '<text class="tide-chart__time" x="' + cx + '" y="' + (H - 6) + '">' + e.time + '</text>';
    }).join('');
    var nowMark = now == null ? '' : '<line class="tide-chart__now" x1="' + x(now) + '" x2="' + x(now) + '" y1="' + (top - 12) + '" y2="' + bottom + '"/>';
    var label = 'Mareas: ' + today.map(function (e) { return (e.high ? 'pleamar ' : 'bajamar ') + e.time + ', ' + e.h.toFixed(1) + ' m'; }).join('; ');
    return '<svg class="tide-chart" viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + label + '">' +
      '<path class="tide-chart__area" d="M0,' + bottom + ' L' + pts.join(' L') + ' L' + W + ',' + bottom + ' Z"/>' +
      '<polyline points="' + pts.join(' ') + '"/><line x1="0" x2="' + W + '" y1="' + bottom + '" y2="' + bottom + '"/>' +
      nowMark + marks + '</svg>';
  }

  function tides(el, spot, tidesUrl) {
    fetch(tidesUrl).then(function (r) { return r.json(); }).then(function (all) {
      var port = all[spot.tidePort] || {};
      var today = new Date().toLocaleDateString('sv-SE', { timeZone: TZ }); // YYYY-MM-DD
      var allDays = Object.keys(port).sort();
      var days = allDays.filter(function (d) { return d >= today; }).slice(0, 3);
      if (!days.length) { el.insertAdjacentHTML('beforeend', '<p>Sin datos de mareas.</p>'); return; }

      // Tide curve of one day (today first), with buttons to step through the days.
      var first = allDays.indexOf(days[0]), shown = first;
      el.insertAdjacentHTML('beforeend', '<div class="tide-nav"><button type="button" class="button button--secondary">‹ Anterior</button>' +
        '<strong aria-live="polite"></strong><button type="button" class="button button--secondary">Siguiente ›</button></div><div class="tide-day"></div>');
      var buttons = el.querySelectorAll('.tide-nav button'), dayName = el.querySelector('.tide-nav strong'), chart = el.querySelector('.tide-day');
      var show = function (i) {
        shown = i;
        var d = allDays[i], hm = new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: TZ }).split(':');
        dayName.textContent = dayLabel(d);
        chart.innerHTML = tideChart(port, allDays, i, d === today ? hm[0] * 60 + +hm[1] : null);
        buttons[0].disabled = i <= first;
        buttons[1].disabled = i >= allDays.length - 1;
      };
      buttons[0].addEventListener('click', function () { show(shown - 1); });
      buttons[1].addEventListener('click', function () { show(shown + 1); });
      show(first);

      var rows = days.map(function (d) {
        var cells = port[d].map(function (t) {
          return '<td class="' + (t[2] ? 'tide-high' : 'tide-low') + '">' + (t[2] ? '▲ ' : '▼ ') + t[0] + '<br><small>' + t[1].toFixed(1) + ' m</small></td>';
        }).join('');
        return '<tr><th>' + dayLabel(d) + '</th>' + cells + '</tr>';
      }).join('');
      el.insertAdjacentHTML('beforeend', '<table class="spot-tides">' + rows + '</table><p class="spot-source">Puerto de referencia: ' +
        PORTS[spot.tidePort] + '. ▲ pleamar, ▼ bajamar. Datos: MeteoGalicia.</p>');
    }).catch(function () { el.insertAdjacentHTML('beforeend', '<p>No se pudieron cargar las mareas.</p>'); });
  }

  function sunMoon(el, spot) {
    if (!window.SunCalc) return;
    var now = new Date();
    var sun = SunCalc.getTimes(now, spot.lat, spot.lon);
    var moon = SunCalc.getMoonTimes(now, spot.lat, spot.lon);
    var illum = Math.round(SunCalc.getMoonIllumination(now).fraction * 100);
    el.insertAdjacentHTML('beforeend', '<ul class="spot-sun">' +
      '<li>Amanecer <strong>' + time(sun.sunrise) + '</strong></li>' +
      '<li>Atardecer <strong>' + time(sun.sunset) + '</strong></li>' +
      '<li>Salida luna <strong>' + time(moon.rise) + '</strong></li>' +
      '<li>Puesta luna <strong>' + time(moon.set) + '</strong></li>' +
      '<li>Luna iluminada <strong>' + illum + '%</strong></li></ul>');
  }

  // spots: an explicit list to show; default is SPOTS minus the secret ones (except the current spot).
  function map(el, current, spots) {
    if (!window.L) return;
    var m = L.map(el, { scrollWheelZoom: false });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(m);
    var bounds = [];
    (spots || SPOTS).forEach(function (spot) {
      if (!spots && spot.secret && spot !== current) return;
      var marker = L.marker([spot.lat, spot.lon], { title: spot.name, opacity: current && spot !== current ? 0.6 : 1 }).addTo(m);
      marker.bindPopup('<strong>' + spot.name + '</strong><br>' + spot.area + '<br><a href="' + pageUrl(spot) + '">Ver condiciones →</a>');
      bounds.push([spot.lat, spot.lon]);
    });
    if (current) m.setView([current.lat, current.lon], 12); else m.fitBounds(bounds, { padding: [30, 30] });
  }

  function renderSpot(root) {
    var spot = SPOTS.filter(function (s) { return s.handle === root.dataset.spot; })[0];
    if (!spot) { root.hidden = true; return; }
    var outlook = block(root, 'Viento y previsión');
    windguru(outlook, spot);
    // shortcut: ours and MeteoGalicia's WRF under Windguru to compare them; ours replaces Windguru once trusted
    forecast(outlook, spot, 7);
    forecast(outlook, spot, 7, true);
    // Webcam providers (camaramar, Surfline, Hispacams, Surftotal) only allow their players on partner sites,
    // so we link to their pages. shortcut: links, not embeds, until a provider grants foilfanatics.com an embed.
    if (spot.cams) block(root, 'Webcams', '<p class="spot-cams">' + spot.cams.map(function (c) {
      return '<a class="button button--secondary" href="' + c[1] + '" target="_blank" rel="noopener">' + c[0] + ' ↗</a>';
    }).join(' ') + '</p>');
    liveWind(block(root, 'Datos actuales'), spot);
    tides(block(root, 'Mareas'), spot, root.dataset.tides);
    sunMoon(block(root, 'Sol y luna'), spot);
    block(root, 'Mapa de viento', iframe('https://embed.windy.com/embed2.html?lat=' + spot.lat + '&lon=' + spot.lon + '&detailLat=' + spot.lat +
      '&detailLon=' + spot.lon + '&zoom=10&level=surface&overlay=wind&product=ecmwf&menu=&message=true&marker=true&calendar=now&type=map' +
      '&location=coordinates&detail=true&metricWind=kt&metricTemp=%C2%B0C', 'Windy ' + spot.name, 'spot-frame spot-frame--tall'));
    var mapEl = block(root, 'Situación', '<div class="spot-map"></div><p><a href="/pages/spots">Todos los spots →</a></p>');
    map(mapEl.querySelector('.spot-map'), spot);
  }

  function renderMap(root) {
    var mapEl = document.createElement('div');
    mapEl.className = 'spot-map spot-map--large';
    root.appendChild(mapEl);
    map(mapEl, null);
  }

  // Spot cards with a square overview map beside them (below on mobile): the public list and the VIP secret list.
  function listWithMap(root, spots) {
    if (!spots.length) { root.innerHTML = '<p>Pronto añadiremos los primeros spots secretos.</p>'; return; }
    root.innerHTML = '<div class="spot-list-wrap"><ul class="spot-list">' + spots.map(function (s) {
      return '<li><a href="' + pageUrl(s) + '"><strong>' + s.name + '</strong> <span>' + s.area + '</span></a></li>';
    }).join('') + '</ul><div class="spot-map spot-map--square"></div></div>';
    map(root.querySelector('.spot-map'), null, spots);
  }

  // The weather API's calendar, fetched once for the calendar and Vista Rápida on the same page.
  var calendarRequest;
  function fetchCalendar() {
    return calendarRequest = calendarRequest || fetch('/apps/foil/calendar').then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  // One row per spot: live wind/gust from our weather API next to the Windguru forecast and our own 3-day one
  // underneath (to compare them), windiest first, by
  // the wind now (mean of the last 2 hours) or by the forecast (top mean wind in the spot's next daylight hours);
  // spots without a value last. All data arrives before any row is drawn, because moving a row reloads its
  // Windguru iframe; switching the order moves the rows, so their iframes reload then.
  // data-locked (set by Liquid for non-members): Liquid already rendered the locked notice; skip the rows.
  var SORT_KEY = 'foilSummarySort';
  function renderSummary(root) {
    if (root.hasAttribute('data-locked')) return;
    var requests = SPOTS.map(function (spot) { return fetchNow(spot); });
    var means = Promise.all(requests.map(function (r) { return r.then(meanWind, function () { return -1; }); }));
    var ahead = fetchCalendar().then(function (cal) { return cal.ahead || null; }, function () { return null; });
    Promise.all([means, ahead]).then(function (res) {
      var today = new Date().toLocaleDateString('sv-SE', { timeZone: TZ });
      var rows = SPOTS.map(function (spot, i) {
        var f = res[1] && res[1][spot.handle], row = document.createElement('div');
        row.className = 'spot-summary';
        row.innerHTML = '<h2 class="h3"><a href="' + pageUrl(spot) + '">' + spot.name + '</a> <small>' + spot.area +
          (res[0][i] < 0 ? '' : ' · media 2 h: ' + Math.round(res[0][i]) + ' kn') +
          (f ? ' · previsión ' + (f.date === today ? 'hoy' : 'mañana') + ': ' + f.wind_kn + ' kn' : '') + '</small></h2>' +
          '<div class="spot-summary__body"><div class="spot-summary__now"></div><div class="spot-summary__forecast"></div></div>';
        return { spot: spot, request: requests[i], row: row, now: res[0][i], forecast: f ? f.wind_kn : -1 };
      });
      var key = 'now';
      try { if (localStorage.getItem(SORT_KEY) === 'forecast' && res[1]) key = 'forecast'; } catch (e) {}
      var buttons = [];
      if (res[1]) { // the forecast order needs the calendar
        root.insertAdjacentHTML('beforeend', '<div class="spot-sort" role="group" aria-label="Ordenar spots"><span>Ordenar por</span>' +
          '<button type="button" data-sort="now">Viento ahora</button><button type="button" data-sort="forecast">Previsión</button>' +
          '<small>Previsión: viento medio máximo previsto en las horas de luz que quedan hoy, o mañana si ya es de noche.</small></div>');
        buttons = [].slice.call(root.querySelectorAll('.spot-sort button'));
        buttons.forEach(function (b) {
          b.addEventListener('click', function () {
            key = b.dataset.sort;
            try { localStorage.setItem(SORT_KEY, key); } catch (e) {}
            order();
          });
        });
      }
      function order() {
        buttons.forEach(function (b) {
          var on = b.dataset.sort === key;
          b.className = on ? 'button' : 'button button--secondary';
          b.setAttribute('aria-pressed', on);
        });
        rows.slice().sort(function (a, b) { return b[key] - a[key]; }) // stable: ties keep the SPOTS order
          .forEach(function (x) { root.appendChild(x.row); });
      }
      order();
      rows.forEach(function (x) {
        liveWind(x.row.querySelector('.spot-summary__now'), x.spot, x.request);
        var el = x.row.querySelector('.spot-summary__forecast');
        windguru(el, x.spot, 72, 'WINDSPD,GUST,SMER');
        forecast(el, x.spot, 3);
        forecast(el, x.spot, 3, true);
      });
    });
  }

  // The spot calendar from our weather API: one column per day with the spots whose forecast has strong wind in
  // daylight, windiest first. Secret spots arrive only for VIP; data-locked as in renderSummary.
  var MODELS = { meteogalicia_wrf_1km: 'WRF 1 km', meteofrance_arome_france_hd: 'AROME HD', meteofrance_arome_france0025: 'AROME', dwd_icon_eu: 'ICON-EU', ecmwf_ifs025: 'ECMWF' };
  function renderCalendar(root) {
    if (root.hasAttribute('data-locked')) return;
    var byHandle = {};
    SPOTS.forEach(function (s) { byHandle[s.handle] = s; });
    fetchCalendar().then(function (cal) {
      root.insertAdjacentHTML('beforeend', '<div class="spot-cal">' + cal.days.map(function (d) {
        var picks = d.spots.filter(function (p) { return byHandle[p.spot]; });
        return '<div class="spot-cal__day' + (d.uncertain ? ' spot-cal__day--uncertain' : '') + '"><h3>' + dayLabel(d.date) +
          (d.uncertain ? ' <small title="Previsión a más de 2 días: más incierta">incierto · ' + d.min_wind_kn + ' kn</small>' : '') +
          '</h3>' + (picks.length ? '<ul>' + picks.map(function (p) {
          var s = byHandle[p.spot];
          return '<li style="border-color:' + knotsColor(p.wind_kn[1]) + '"><a href="' + pageUrl(s) + '"><strong>' + s.name + '</strong></a>' +
            '<span>' + p.wind_kn[0] + '–' + p.wind_kn[1] + ' kn' + (p.dir == null ? '' : ' ' + DIRS[Math.round(p.dir / 45) % 8]) +
            (p.gust_kn ? ' · racha ' + p.gust_kn : '') + '</span>' +
            '<small>' + p.from + '–' + p.to + ' · ' + p.models.map(function (m) { return MODELS[m] || m; }).join(', ') + '</small></li>';
        }).join('') + '</ul>' : '<p class="spot-cal__none">Sin viento</p>') + '</div>';
      }).join('') + '</div><p class="spot-source">Spots con viento medio de ' + cal.min_wind_kn + ' kn o más durante al menos 2 horas de luz, ' +
        'según la previsión: AROME los 2 primeros días. Después, ICON-EU y ECMWF, más gruesos y a más días vista: ' +
        'esos días, marcados como inciertos, cuentan desde ' + ((cal.days.filter(function (d) { return d.uncertain; })[0] || {}).min_wind_kn || cal.min_wind_kn) +
        ' kn y conviene volver a mirarlos más cerca de la fecha. Datos: Open-Meteo (CC BY 4.0).</p>');
    }).catch(function () { root.insertAdjacentHTML('beforeend', '<p>No se pudo cargar el calendario.</p>'); });
  }

  document.querySelectorAll('[data-spot]').forEach(renderSpot);
  document.querySelectorAll('[data-spots-calendar]').forEach(renderCalendar);
  document.querySelectorAll('[data-spots-list]').forEach(function (el) { listWithMap(el, SPOTS.filter(function (s) { return !s.secret; })); });
  document.querySelectorAll('[data-secret-spots]').forEach(function (el) { listWithMap(el, SPOTS.filter(function (s) { return s.secret; })); });
  document.querySelectorAll('[data-spots-summary]').forEach(renderSummary);
  document.querySelectorAll('[data-spots-map]').forEach(renderMap);
})();
